import React from 'react';
import './Login.css';
import AmbientStage from '../components/AmbientStage';
import logo from '../assets/logo.png';
import fabricImg from '../assets/fabric.png';
import arrowIcon from '../assets/arrow.png';

function Login({ goNext }) {
  return (
    <AmbientStage className="login-screen" image={fabricImg}>
      <div className="login-marquee">
        <span>Visitor Pass</span>
        <span>Visitor Pass</span>
        <span>Visitor Pass</span> 
      </div>

      <div className="auth-card">
        <img className="auth-logo" src={logo} alt="Exhibition logo" />
        <p className="eyebrow">Access your pass</p>
        <h2>Sign in to unlock the floor.</h2>

        <label>
          Email
          <input type="email" placeholder="name@email.com" />
        </label>
        <label>
          Password
          <input type="password" placeholder="********" />
        </label>

        <button className="gold-action full" onClick={goNext} type="button">
          Log In
          <img src={arrowIcon} alt="" aria-hidden="true" />
        </button>
        <button className="outline-action" type="button">Create Account</button>
      </div>

      <div className="ticket-strip">
        <span>Hall A</span>
        <span>Smart Factory Demo</span>
        <span>06:30 PM</span>
      </div>
    </AmbientStage>
  );
}

export default Login;
